import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { userService } from '../../services/user.service';
import {
    FaSearch,
    FaEnvelope,
    FaPhone,
    FaUsers,
    FaUserCheck,
    FaUserClock
} from 'react-icons/fa';

const ManagerTeam = () => {
    const [teamMembers, setTeamMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        inactive: 0
    });

    useEffect(() => {
        fetchTeamMembers();
    }, []);

    const fetchTeamMembers = async () => {
        try {
            setLoading(true);

            const data = await userService.getAllUsers({ status: 'active' });

            console.log("FULL RESPONSE:", data);

            // ✅ FIXED
            const members = data.users || [];

            console.log("FIRST MEMBER:", members[0]);

            setTeamMembers(members);

            // stats
            setStats({
                total: members.length,
                active: members.filter(m => m.status === 'active').length,
                inactive: members.filter(m => m.status !== 'active').length
            });

        } catch (error) {
            toast.error('Failed to fetch team members');
        } finally {
            setLoading(false);
        }
    };

    const getRoleName = (role) => {
        if (!role) return 'No Role';

        if (typeof role === 'string') return role;

        return role.displayName || role.name || 'No Role';
    };

    const filteredMembers = teamMembers.filter(member =>
        member.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        member.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        getRoleName(member.role).toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="p-6">

            {/* HEADER */}
            <div className="mb-6">
                <h1 className="text-3xl font-bold">My Team</h1>
                <p className="text-gray-600 mt-2">View and manage your team members</p>
            </div>

            {/* STATS (NEW - CONSISTENT UI) */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                <Stat title="Total Members" value={stats.total} icon={<FaUsers />} />
                <Stat title="Active" value={stats.active} icon={<FaUserCheck />} />
                <Stat title="Inactive" value={stats.inactive} icon={<FaUserClock />} />
            </div>

            {/* SEARCH */}
            <div className="bg-white rounded-lg shadow p-4 mb-6">
                <div className="relative">
                    <FaSearch className="absolute left-3 top-3 text-gray-400" />
                    <input
                        type="text"
                        placeholder="Search team members..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border rounded-lg"
                    />
                </div>
            </div>

            {/* GRID */}
            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <div className="animate-spin h-12 w-12 border-b-2 border-blue-600 rounded-full"></div>
                </div>
            ) : filteredMembers.length === 0 ? (
                <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">
                    No team members found
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                    {filteredMembers.map((member) => (
                        <div key={member._id} className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition">

                            <div className="flex gap-4">

                                {/* AVATAR */}
                                <div className="h-16 w-16 rounded-full bg-blue-600 flex items-center justify-center text-white text-2xl font-bold">
                                    {member.name?.charAt(0) || 'U'}
                                </div>

                                <div className="flex-1">

                                    <h3 className="font-bold text-lg">{member.name}</h3>

                                    {/* ✅ FIXED ROLE */}
                                    <p className="text-sm text-gray-600 mb-2">
                                        {getRoleName(member.role)}
                                    </p>

                                    {/* EMAIL */}
                                    <div className="flex items-center gap-2 text-sm text-gray-700">
                                        <FaEnvelope />
                                        <span className="truncate">{member.email}</span>
                                    </div>

                                    {/* PHONE */}
                                    {member.phone && (
                                        <div className="flex items-center gap-2 text-sm text-gray-700 mt-1">
                                            <FaPhone />
                                            <span>{member.phone}</span>
                                        </div>
                                    )}

                                    {/* DETAILS */}
                                    <div className="mt-3 pt-2 border-t text-xs text-gray-500">

                                        <p>
                                            <strong>Department:</strong> {member.department?.name || 'N/A'}
                                        </p>

                                        <p>
                                            <strong>Employee ID:</strong> {member.employeeId || 'N/A'}
                                        </p>

                                        <p className="mt-1">
                                            <strong>Status:</strong>{' '}
                                            <span className={`px-2 py-0.5 rounded ${member.status === 'active'
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-gray-100 text-gray-800'
                                                }`}>
                                                {member.status}
                                            </span>
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>
                    ))}

                </div>
            )}

            {/* SUMMARY */}
            {!loading && (
                <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <p className="text-sm text-blue-800">
                        <strong>Total Team Members:</strong> {filteredMembers.length}
                    </p>
                </div>
            )}

        </div>
    );
};

// STAT CARD
const Stat = ({ title, value, icon }) => (
    <div className="bg-white p-6 rounded-lg shadow flex justify-between">
        <div>
            <p className="text-gray-500 text-sm">{title}</p>
            <p className="text-xl font-bold">{value}</p>
        </div>
        <div className="text-2xl text-blue-500">{icon}</div>
    </div>
);

export default ManagerTeam;